var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"footer__copy"},[_vm._v("© 2026 fkxsh")])])
}]

export { render, staticRenderFns }